import React from 'react';
import { FaGlobe, FaCreditCard, FaPlane } from 'react-icons/fa';
import './EasySteps.css';

const EasySteps = () => {
  const steps = [
    {
      id: 1,
      icon: <FaGlobe />,
      title: 'Choose a Destination',
      description: 'Select from our wide range of destinations across India of your choice.'
    },
    {
      id: 2,
      icon: <FaCreditCard />,
      title: 'Connect on Call or WhatsApp',
      description: 'Chat with us on WhatsApp to know the full details and book your trip instantly.'
    },
    {
      id: 3,
      icon: <FaPlane />,
      title: 'You Are Ready to Go',
      description: 'Get ready to create memories for a lifetime with an amazing adventure.'
    }
  ];
  

  return (
    <section className="section easy-steps">
      <div className="container">
        <div className="section-title">
          <h2 className="section-heading">3 Easy Steps</h2>
        </div>
        
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={step.id} className="step-card">
              <div className="step-number">{index + 1}</div>
              <div className="step-icon">
                {step.icon}
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EasySteps;